import {Button, InputNumber, message, Modal, Radio, Space, Table} from 'antd'
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useEffect, useState} from "react";
import service from "../../../@services";
import QueryString from "qs";
import {useLocation} from "react-router-dom";
import PriceEditTable from "../../Product/components/PriceEditTable";

export default function EditVirtual(props){
    const {visible,close,data,storeCode,batchUpdatePrice=()=>{}} = props
    const [tableData, setTableData] = useState([])
    useEffect(()=>{
        setTableData(data)
    },[data])

    const submit = () => {
        let newList = [];
        (tableData || []).forEach((item)=>{
            let newObject = {}
            newObject.skuId = item.skuId
            newObject.stock = item.stock
            newObject.storeCode = storeCode
            newList.push(newObject)
        })
        const params = {
            items: newList
        }
        Modal.confirm({
            title: '提示',
            icon: <ExclamationCircleOutlined />,
            content: `确认要提交么吗？`,
            okText: '确认',
            cancelText: '取消',
            onOk: async ()=>{
                await service.inventory.updateonlineList(params)
                message.success('操作成功');
                close()
            }
        });
    }

    const changestock = (e,index)=>{
        const newData = tableData
        newData[index].stock = e
        setTableData(newData)
    }

    const columns = [
        {
            title: '序号',
            dataIndex: '',
            key: 'index',
            render: (text,record,index)=> index+1 },
        {
            title: '商品名称',
            dataIndex: 'productName',
            render: (text, record) => (
                <div style={{ fontSize: 12 }}>
                    <div style={{ color: '#1890ff' }}>{record.productName}</div>
                    <div>商品编码：{record.productCode}</div>
                    <div>商品条码：{record.barcode}</div>
                </div>
            )
        },
        {
            title: '商品类别',
            dataIndex: 'categoryName'
        },
        {
            title: '规格',
            dataIndex: 'specification'
        },
        {
            title: '单位',
            dataIndex: 'unit'
        },
        {
            title: '当前剩余库存',
            dataIndex: 'stock',
            render: (text, record, index) => {
                return (
                    <InputNumber key={record.skuId} min={1} defaultValue={record.stock} onChange={(e)=>changestock(e,index)} />
                )
            }
        }
    ]

    return(
        <Modal
            visible={visible}
            width="60%"
            title="批量设置销售库存"
            onCancel={close}
            onOk={()=>submit()}
            cancelText="取消"
            okText="保存"
        >
            <Table
                rowKey={record=>record.skuId}
                pagination={false}
                dataSource={data}
                columns={columns}
            />
        </Modal>
    )
}
